import { call, put, takeEvery, all } from 'redux-saga/effects';
import {
  DOCUMENTS_GET,
  DOCUMENT_FILES_GET,
  DOCUMENT_FILES_POST,
  DOCUMENT_FILE_GET,
} from '../actions/types';
import { actionSpinnerClose, actionSpinnerOpen } from '../actions';
import { createQadraSaga } from './shared';
import { apiDocumentFilePost, apiDocumentFileGet } from '../api/documents';
import { apiUserDocumentsGet } from '../api/user';

// User documents
export function* documentFilePost({ file, documentId, showSpinner }) {
  if (!file) return;
  try {
    const formData = new FormData();
    formData.append('file', new File([file.file || file], file.name || file));

    // formData.append('file', new Blob([file.file || file], { type: 'image/png' }), file.name);

    if (showSpinner) yield put(actionSpinnerOpen());

    yield call(apiDocumentFilePost, documentId, { file: formData });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('saga > fileUpload > fileUpload', e.message);
    if (!showSpinner) throw e;
  } finally {
    if (showSpinner) yield put(actionSpinnerClose());
  }
}

function* watchDocumentFilePost() {
  yield takeEvery(DOCUMENT_FILES_POST._REQUEST, documentFilePost);
}

function* documentsGet({ payload: { userId } }) {
  const { documents } = yield call(apiUserDocumentsGet, userId);
  yield put({ type: DOCUMENTS_GET._SUCCESS, payload: { documents, userId } });
}

const watchDocumentsGet = createQadraSaga(documentsGet, {
  action: DOCUMENTS_GET._REQUEST,
});

function* documentsFilesGet({ payload: { document } }) {
  const { documentFiles, id: documentId } = document;
  let newFiles = [];
  if (documentFiles) {
    const calls = documentFiles.map((f) => call(apiDocumentFileGet, f.documentId, f.id));
    const res = yield all(calls);
    newFiles = [...res];
    const filesMap = documentFiles.reduce((obj, file, i) => {
      const newObj = { ...obj };
      newObj[file.id] = { ...file, ...newFiles[i] };
      return newObj;
    }, {});

    yield put({
      type: DOCUMENT_FILES_GET._SUCCESS,
      payload: { documentId, documentFiles: filesMap },
    });
  }
}

const watchDocumentsFilesGet = createQadraSaga(documentsFilesGet, {
  action: DOCUMENT_FILES_GET._REQUEST,
});

function* documentsFileGet({ payload: { documentId, fileId } }) {
  const res = yield call(apiDocumentFileGet, documentId, fileId);

  yield put({
    type: DOCUMENT_FILE_GET._SUCCESS,
    payload: { documentId, fileId, file: res },
  });
}

const watchDocumentsFileGet = createQadraSaga(documentsFileGet, {
  action: DOCUMENT_FILE_GET._REQUEST,
});

export default [
  watchDocumentFilePost,
  watchDocumentsGet,
  watchDocumentsFilesGet,
  watchDocumentsFileGet,
];
